import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./PortfolioPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import {portfolio} from "../../data";
import ProjectCards from "../../Common/Tab"


function App() {
  return (
    <X03PortfolioPageTablet
      ourProjects="Our Projects"
      rectangle78="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-78@1x.png"
    text167="The WeBuildd team of highly skilled and dedicated professionals has been delivering successful projects across all asset classes including, industrial, manufacturing, biotech, residential, healthcare, education, mixed-use, and retail for decades."
    text1672= "We believe that quality construction is much more than choosing materials and craftsmanship. We strive to create an experience our clients can enjoy throughout the construction process. And we deliver beyond the expected so that you have the best possible solution."
    text1673= "As evidenced from our projects, we pay strict attention to small details. As a third-generation family-owned construction firm, we have evolved into a highly-regarded, fully integrated construction firm because our commitment to exceptional quality has never wavered. We are proud of our reputation for quality work and on-time delivery of projects."
    text1674= "We are consistently bringing our clients appropriate and more efficient building solutions in Bengaluru and beyond. We are environmentally responsible. And we have also developed strong working relationships with vendors, which helps minimize costs and unnecessary delays."
    text1675= "Look at our featured projects below:"
      frame144Props={x03PortfolioPageTabletData.frame144Props}
      frame149Props={x03PortfolioPageTabletData.frame149Props}
      button22Props={x03PortfolioPageTabletData.button22Props}
      //footerProps={x03PortfolioPageTabletData.footerProps}
    />
  );
}

export default App;

function X03PortfolioPageTablet(props) {
  const { ourProjects, rectangle78, text167,text1672,text1673,text1674,text1675, frame144Props, frame149Props, button22Props, footerProps } = props;

  return (
    <div className="ppt-container-center-horizontal">
      <div className="ppt-x03-portfolio-page-tablet ppt-screen">
        {/* <Frame144 group86Props={frame144Props.group86Props} iconMenuProps={frame144Props.iconMenuProps} /> */}
        <NavBar/>
        <h1 className="ppt-title ppt-valign-text-middle ppt-typographyheadlineh4-extrabold-24">{ourProjects}</h1>
        {/* <img className="ppt-rectangle-78" src={rectangle78} /> */}
        <img className="ppt-rectangle-78" src={portfolio.PortfolioHeader} alt="Webuildd Projects"/>
        <div className="ppt-text-1 ppt-typography-body-smalltext-14-regular">
          <p>{text167}</p>
          <p>{text1672}</p>
          <p>{text1673}</p>
          <p>{text1674}</p>
          <p>{text1675}</p>
        </div>
        {/* <div className="ppt-frame-1610">
        
          <Frame149 {...frame149Props} />
          <Button22>{button22Props.children}</Button22>
       
        </div> */}
          <ProjectCards />
          <Footer />
      </div>
      
    </div>
  );
}


function Frame144(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="ppt-frame-144">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="ppt-group-86">
      <White src={whiteProps.src} />
      <img className="ppt-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="ppt-white">
      <img className="ppt-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="ppt-icon-menu">
      <img
        className="ppt-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="ppt-vector-1" src={vector2} />
      <img className="ppt-vector-1" src={vector3} />
    </div>
  );
}


function Frame149(props) {
  const {
    apartments,
    buildiings,
    group139Props,
    frame138Props,
    group13022Props,
    group135Props,
    group1352Props,
    group135Props2,
    group137Props,
    group135Props3,
    group1352Props2,
    group1372Props,
  } = props;

  return (
    <div className="ppt-frame-149">
      <div className="ppt-frame-1609">
        <Group139>{group139Props.children}</Group139>
        <div className="ppt-apartments ppt-typographybodycaption-14-semi-bold">{apartments}</div>
        <div className="ppt-buildiings ppt-typographybodycaption-14-semi-bold">{buildiings}</div>
        <Frame138 place={frame138Props.place} living={frame138Props.living} />
      </div>
      <div className="ppt-frame-15">
        <Group13022
          rectangle62={group13022Props.rectangle62}
          text107={group13022Props.text107}
          surname={group13022Props.surname}
        />
        <Group135
          rectangle62={group135Props.rectangle62}
          text108={group135Props.text108}
          surname={group135Props.surname}
        />
      </div>
      <div className="ppt-frame-15">
        <Group135
          rectangle62={group1352Props.rectangle62}
          text108={group1352Props.text108}
          surname={group1352Props.surname}
          className={group1352Props.className}
        />
        <Group135
          rectangle62={group135Props2.rectangle62}
          text108={group135Props2.text108}
          surname={group135Props2.surname}
        />
      </div>
      <div className="ppt-frame-15-1">
        <Group137
          rectangle62={group137Props.rectangle62}
          text111={group137Props.text111}
          surname={group137Props.surname}
        />
        <Group135
          rectangle62={group135Props3.rectangle62}
          text108={group135Props3.text108}
          surname={group135Props3.surname}
        />
      </div>
      <div className="ppt-frame-15-1">
        <Group135
          rectangle62={group1352Props2.rectangle62}
          text108={group1352Props2.text108}
          surname={group1352Props2.surname}
          className={group1352Props2.className}
        />
        <Group137
          rectangle62={group1372Props.rectangle62}
          text111={group1372Props.text111}
          surname={group1372Props.surname}
          className={group1372Props.className}
        />
      </div>
    </div>
  );
}


function Group139(props) {
  const { children } = props;

  return (
    <div className="ppt-group-139">
      <div className="ppt-overlap-group">
        <div className="ppt-rectangle-46"></div>
        <div className="ppt-price">{children}</div>
      </div>
    </div>
  );
}


function Frame138(props) {
  const { place, living } = props;

  return (
    <div className="ppt-frame-138">
      <div className="ppt-place ppt-typographybodycaption-14-semi-bold">{place}</div>
      <div className="ppt-living ppt-typographybodycaption-14-semi-bold">{living}</div>
    </div>
  );
}


function Group13022(props) {
  const { rectangle62, text107, surname } = props;

  return (
    <div className="ppt-group-130">
      <img className="ppt-rectangle-62" src={rectangle62} />
      <div className="ppt-group-99">
        <div className="ppt-text-2 ppt-valign-text-middle ppt-typographyheadlineh4-extrabold-24">{text107}</div>
        <p className="ppt-surname ppt-typography-body-smalltext-14-regular">{surname}</p>
      </div>
    </div>
  );
}


function Group135(props) {
  const { rectangle62, text108, surname, className } = props;

  return (
    <div className={`ppt-group-13 ${className || ""}`}>
      <img className="ppt-rectangle-62-1" src={rectangle62} />
      <div className="ppt-group-99-1">
        <div className="ppt-text ppt-valign-text-middle ppt-typographyheadlineh4-extrabold-24">{text108}</div>
        <p className="ppt-surname-1 ppt-typography-body-smalltext-14-regular">{surname}</p>
      </div>
    </div>
  );
}


function Group137(props) {
  const { rectangle62, text111, surname, className } = props;

  return (
    <div className={`ppt-group-137 ${className || ""}`}>
      <img className="ppt-rectangle-62-2" src={rectangle62} />
      <div className="ppt-group-99-2">
        <div className="ppt-text-3 ppt-valign-text-middle ppt-typographyheadlineh4-extrabold-24">{text111}</div>
        <p className="ppt-surname-2 ppt-typography-body-smalltext-14-regular">{surname}</p>
      </div>
    </div>
  );
}


function Button22(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x27320738TimelineData);
  }, []);

  return (
    <div className="ppt-x27320738 ppt-component ppt-component-wrapper ppt-not-ready">
      <div className="ppt-master-button-NKD4jo">
        <div className="ppt-button-i2732073851-Ykr3iW ppt-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x27320738TimelineData = [
  {
    initial_state_name: "Property-1=Tertiary",
    root_element: ".x27320738",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


// function Footer5(props) {
//   const {
//     group85,
//     place,
//     overlapGroup,
//     vector2,
//     phone,
//     overlapGroup1,
//     vector3,
//     text15,
//     text14,
//     contactWebuildCom,
//     quickLinks,
//     aboutUs,
//     projects,
//     gallery,
//     knowledgeTransfer,
//     blogs,
//     faqs,
//     group872Props,
//   } = props;

//   return (
//     <div className="ppt-footer">
//       <div className="ppt-flex-row-1">
//         <img
//           className="ppt-vector-3"
//           src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
//         />
//         <img className="ppt-group-85-1" src={group85} />
//         <Group872
//           overlapGroup={group872Props.overlapGroup}
//           vector2={group872Props.vector2}
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <div className="ppt-flex-row-2">
//         <div className="ppt-group-32">
//           <div className="ppt-place-1 ppt-valign-text-middle ppt-typographyheadlineh5-extrabold-20">{place}</div>
//           <div className="ppt-flex-row-3">
//             <div className="ppt-flex-col">
//               <div className="ppt-map-pin-1">
//                 <div className="ppt-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup})` }}>
//                   <img className="ppt-vector-4" src={vector2} />
//                 </div>
//               </div>
//               <div className="ppt-phone" style={{ backgroundImage: `url(${phone})` }}></div>
//               <div className="ppt-mail">
//                 <div className="ppt-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//                   <img className="ppt-vector-5" src={vector3} />
//                 </div>
//               </div>
//             </div>
//             <div className="ppt-flex-col-1">
//               <p className="ppt-text-11 ppt-typography-body-smalltext-14-regular">{text15}</p>
//               <div className="ppt-flex-col-item ppt-valign-text-middle ppt-typography-body-smalltext-14-regular">{text14}</div>
//               <div className="ppt-flex-col-item ppt-valign-text-middle ppt-typography-body-smalltext-14-regular">
//                 {contactWebuildCom}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="ppt-group-147">
//           <div className="ppt-quick-links ppt-valign-text-middle ppt-typographyheadlineh5-extrabold-20">{quickLinks}</div>
//           <div className="ppt-flex-row-4">
//             <div className="ppt-about-us ppt-valign-text-middle ppt-typographybody16-regular">{aboutUs}</div>
//             <div className="ppt-projects ppt-valign-text-middle ppt-typographybody16-regular">{projects}</div>
//           </div>
//           <div className="ppt-flex-row">
//             <div className="ppt-gallery ppt-valign-text-middle ppt-typographybody16-regular">{gallery}</div>
//             <div className="ppt-knowledge-transfer ppt-valign-text-middle ppt-typographybody16-regular">{knowledgeTransfer}</div>
//           </div>
//           <div className="ppt-flex-row">
//             <div className="ppt-blogs ppt-valign-text-middle ppt-typographybody16-regular">{blogs}</div>
//             <div className="ppt-fa-qs ppt-valign-text-middle ppt-typographybody16-regular">{faqs}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


function Group872(props) {
  const { overlapGroup, vector2, facebookAppSymbolProps, twitterProps } = props;

  return (
    <div className="ppt-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <div className="ppt-instagram">
        <div className="ppt-overlap-group-2" style={{ backgroundImage: `url(${overlapGroup})` }}>
          <img
            className="ppt-vector-6"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-155@2x.svg"
          />
          <img className="ppt-vector-7" src={vector2} />
        </div>
      </div>
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="ppt-facebook-app-symbol">
      <img className="ppt-f-1" src={src} />
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="ppt-twitter">
      <img className="ppt-vector-8" src={src} />
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-13@2x.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame144Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const group139Data = {
    children: "ALL",
};

const frame138Data = {
    place: "INTERIOR",
    living: "LIVING",
};

const group13022Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-33@2x.png",
    text107: "Project Name",
    surname: "Small description about the project",
};

const group135Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-34@2x.png",
    text108: "Project Name",
    surname: "Small description about the project",
};

const group1352Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-35@2x.png",
    text108: "Project Name",
    surname: "Small description about the project",
    className: "ppt-group-13-1",
};

const group1353Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-36@2x.png",
    text108: "Project Name",
    surname: "Small description about the project",
};

const group137Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-37@2x.png",
    text111: "Project Name",
    surname: "Small description about the project",
};

const group1354Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-38@2x.png",
    text108: "Project Name",
    surname: "Small description about the project",
};

const group1355Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-39@2x.png",
    text108: "Project Name",
    surname: "Small description about the project",
    className: "ppt-group-13-1",
};

const group1372Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-40@2x.png",
    text111: "Project Name",
    surname: "Small description about the project",
    className: "ppt-group-133",
};

const frame149Data = {
    apartments: "APARTMENTS",
    buildiings: "BUILDIINGS",
    group139Props: group139Data,
    frame138Props: frame138Data,
    group13022Props: group13022Data,
    group135Props: group135Data,
    group1352Props: group1352Data,
    group135Props2: group1353Data,
    group137Props: group137Data,
    group135Props3: group1354Data,
    group1352Props2: group1355Data,
    group1372Props: group1372Data,
};

const button22Data = {
    children: "VIEW MORE",
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-347@2x.svg",
};

const group872Data = {
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-112@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-346@2x.svg",
    facebookAppSymbolProps: facebookAppSymbolData,
    twitterProps: twitterData,
};

// const footer5Data = {
//     group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-25@2x.svg",
//     place: "Contact",
//     overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg",
//     phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-151@2x.svg",
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-264@2x.svg",
//     vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-111@2x.svg",
//     text15: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
//     text14: "+91 8976535221, +91 8755645342",
//     contactWebuildCom: "contact@webuild.com",
//     quickLinks: "Quick Links",
//     aboutUs: "About Us",
//     projects: "Projects",
//     gallery: "Gallery",
//     knowledgeTransfer: "Knowledge Transfer",
//     blogs: "Blogs",
//     faqs: "FAQ’s",
//     group872Props: group872Data,
// };

const x03PortfolioPageTabletData = {
    ourProjects: "Our Projects",
    rectangle78: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-78@1x.png",
    text167: "There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy alteration in that an some form by the injected humour or randomised words which don’t look even that slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing. There are many variations passages of Lorem as Ipsums available but the majority have suffered that alterations in that some form by injected humour or randomised words which don’t looks even slightly that believable. If you are Lorem as Ipsum  you need to be sure there isn’t anything as embarrassing. There are many variation of passages Lorem Ipsum available but the majority have suffered that a aalteration in that some form by injected humour or randomised words which don’t look even slightly the believable.",
    frame144Props: frame144Data,
    frame149Props: frame149Data,
    button22Props: button22Data,
    //footerProps: footer5Data,
};

